// @flow strict

import React from 'react';

import { SvgIcon, type SvgIconComponentProps } from './svg-icon';

/**
 * Icon for mobile menu (open menu).
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const MobileMenuOpenIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 26 19" name="OMQMobileMenuOpenIcon" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FF6602"
        strokeLinecap="square"
        strokeWidth="2"
      >
        <path
          d="M.387 1L23.387 1M.391 9.5L23.391 9.5M.387 17.5L15.891 17.5 23.387 17.5"
          transform="translate(1)"
        />
      </g>
    </SvgIcon>
  );
};

/**
 * Icon for mobile menu (close menu).
 *
 * @param {SvgIconComponentProps} props - component props
 *
 * @returns {Node}
 */
export const MobileMenuCloseIcon = (props: SvgIconComponentProps) => {
  return (
    <SvgIcon viewBox="0 0 20 21" name="OMQMobileMenuCloseIcon" {...props}>
      <g
        fill="none"
        fillRule="evenodd"
        stroke="#FF6602"
        strokeLinecap="square"
        strokeWidth="2"
      >
        <path
          d="M.76.368L17.023 16.632M.76.368L17.023 16.632"
          transform="translate(1 2) matrix(-1 0 0 1 18 0)"
        />
        <path d="M0.76 0.368L17.023 16.632" transform="translate(1 2)" />
      </g>
    </SvgIcon>
  );
};
